import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              trackers: {
                tab_name: 'TAB_NAME',
                button_add_tracker: 'SETTINGS_TRACKERS_ADD_TRACKER',
                edit_tracker_condition: 'EDIT_TRACKER_CONDITION',
                bulk_replacement_deals: 'BULK_REPLACEMENT_DEALS',
                bulk_changing_fixed_payment: 'BULK_CHANGING_FIXED_PAYMENT',
                bulk_changing_tracker_country: 'BULK_CHANGING_TRACKER_COUNTRY',
                bulk_changing_traffic_source: 'BULK_CHANGING_TRAFFIC_SOURCE',
                save_traffic_source_warning: 'SAVE_TRAFFIC_SOURCE_WARNING',
                cannot_change_traffic_source_info: 'CANNOT_CHANGE_TRAFFIC_SOURCE_INFO',
                save_tracker_country_warning: 'SAVE_TRACKER_COUNTRY_WARNING',
                form: {
                  merchant_name: 'SETTINGS_TRACKERS_MERCHANT_NAME',
                  tracker: 'SETTINGS_TRACKERS_FORM_TRACKER',
                  condition: 'SETTINGS_TRACKERS_FORM_CONDITION',
                  date: 'SETTINGS_TRACKERS_FORM_DATE',
                },
                table_actions: {
                  edit_tracker_description: 'SETTINGS_TRACKERS_EDIT_TRACKER_DESCRIPTION',
                  edit_traffic_source: 'SETTINGS_TRACKERS_EDIT_TRAFFIC_SOURCE',
                  edit_tracker_condition: 'SETTINGS_TRACKERS_EDIT_TRACKER_CONDITION',
                  edit_tracker_country: 'SETTINGS_TRACKERS_EDIT_TRACKER_COUNTRY',
                  edit_fixed_payments: 'SETTINGS_TRACKERS_EDIT_FIXED_PAYMENTS',
                },
                modal_window: {
                  title_for_add: 'CREATE_TRACKER_TITLE',
                  description: 'CREATE_TRACKER_DESCRIPTION',
                  answer_yes: 'CREATE_TRACKER_SAVE',
                  answer_no: 'CREATE_TRACKER_CANCEL',
                  edit_description: {
                    title: 'EDIT_TRACKER_TITLE',
                    description: 'EDIT_TRACKER_DESCRIPTION',
                    answer_yes: 'EDIT_TRACKER_SAVE',
                    answer_no: 'EDIT_TRACKER_CANCEL',
                  },
                  edit_tracker_country: {
                    title: 'EDIT_TRACKER_COUNTRY_TITLE',
                    country: 'EDIT_TRACKER_COUNTRY_LABEL',
                    save: 'EDIT_TRACKER_COUNTRY_SAVE',
                    you_cannot_change_country: 'EDIT_TRACKER_COUNTRY_CANNOT_CHANGE',
                  },
                  edit_traffic_source: {
                    title: 'EDIT_TRAFFIC_SOURCE_TITLE',
                    department: 'EDIT_TRAFFIC_SOURCE_DEPARTMENT',
                    traffic_source: 'EDIT_TRAFFIC_SOURCE_TRAFFIC_SOURCE',
                    cancel: 'EDIT_TRAFFIC_SOURCE_CANCEL',
                    save: 'EDIT_TRAFFIC_SOURCE_SAVE',
                  },
                  bulk_replacement_deals: {
                    title: 'BULK_REPLACEMENT_DEALS_TITLE',
                    cancel: 'BULK_REPLACEMENT_DEALS_CANCEL',
                    save: 'BULK_REPLACEMENT_DEALS_SAVE',
                  },
                  bulk_changing_fixed_payment: {
                    title: 'BULK_CHANGING_FIXED_PAYMENT_TITLE',
                    cancel: 'BULK_CHANGING_FIXED_PAYMENT_CANCEL',
                    save: 'BULK_CHANGING_FIXED_PAYMENT_SAVE',
                  },
                  bulk_changing_traffic_source: {
                    title: 'BULK_CHANGING_TRAFFIC_SOURCE_TITLE',
                    cancel: 'BULK_CHANGING_TRAFFIC_SOURCE_CANCEL',
                    save: 'BULK_CHANGING_TRAFFIC_SOURCE_SAVE',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
